export default values => ({
  ...values,
  phone: values.phone || '',
  email: values.email || '',
  emailValidate: values.emailValidate || '',
  phoneValidate: values.phoneValidate || '',
  personType: values.personType || '',
  rfc: values.rfc || '',
  curp: values.curp || '',
  name: values.name || '',
  paternalName: values.paternalName || '',
  maternalName: values.maternalName || '',
  denomination: values.denomination || '',
  sex: values.sex || 'H'
});
